import { Box, Card, CardContent, Grid, Slider, Typography } from '@mui/material';
import useTheme from '@mui/material/styles/useTheme';
import { Theme } from '@mui/system';
import { useContext, useState } from 'react';
import BackNavigationButton from '../../../components/common/BackNavigationButton';
import useSubscriber from '../../../hooks/useSubscriber';
import { SettingsContext } from '../../../store/SettingsContext';

import * as d3 from 'd3';
import moment from 'moment';
import { useEffect, useRef } from 'react';
import PageContainer from '../../../components/common/PageContainter';
import useSubscriberPerformerTop from '../../../hooks/useSubscriberPerformerTop';
import PerformerRankingMyRankingCard from './PerformerRankingMyRankingCard';

const data: PerformerRankingDataPoint[] = [
    {
        ranking: '0.01',
        min: 358421.39,
        avg: 360328.52,
        max: 362235.65,
    },
    {
        ranking: '0.02',
        min: 266916.29,
        avg: 291086.56999999995,
        max: 315256.85,
    },
    {
        ranking: '0.03',
        min: 220107.13,
        avg: 220780.065,
        max: 221453,
    },
    {
        ranking: '0.04',
        min: 187764.02,
        avg: 197862.8,
        max: 207961.58,
    },
    {
        ranking: '0.05',
        min: 176639.88,
        avg: 178171.695,
        max: 179703.51,
    },
    {
        ranking: '0.06',
        min: 149290.69,
        avg: 157251.625,
        max: 165212.56,
    },
    {
        ranking: '0.07',
        min: 140503.3,
        avg: 150584.01,
        max: 160664.72,
    },
    {
        ranking: '0.08',
        min: 135560.79,
        avg: 140642.79499999998,
        max: 145724.8,
    },
    {
        ranking: '0.09',
        min: 125670.14,
        avg: 135899.03,
        max: 146127.92,
    },
    {
        ranking: '0.10',
        min: 119601.71,
        avg: 123156.755,
        max: 126711.8,
    },
    {
        ranking: '0.11',
        min: 113384.95,
        avg: 116745.19,
        max: 120105.43,
    },
    {
        ranking: '0.12',
        min: 106657.43,
        avg: 112511.91,
        max: 118366.39,
    },
    {
        ranking: '0.13',
        min: 100290.6,
        avg: 105635.395,
        max: 110980.19,
    },
    {
        ranking: '0.14',
        min: 99526.79,
        avg: 102431.195,
        max: 105335.6,
    },
    {
        ranking: '0.15',
        min: 94324.52,
        avg: 95172.655,
        max: 96020.79,
    },
    {
        ranking: '0.16',
        min: 91523.43,
        avg: 93729.13,
        max: 95934.83,
    },
    {
        ranking: '0.17',
        min: 87484.26,
        avg: 90691.4,
        max: 93898.54,
    },
    {
        ranking: '0.18',
        min: 84198.3,
        avg: 87657.5,
        max: 91116.7,
    },
    {
        ranking: '0.19',
        min: 77482.16,
        avg: 81164.375,
        max: 84846.59,
    },
    {
        ranking: '0.20',
        min: 81181.69,
        avg: 82539.405,
        max: 83897.12,
    },
    {
        ranking: '0.21',
        min: 76420.09,
        avg: 81981.595,
        max: 87543.1,
    },
    {
        ranking: '0.22',
        min: 76582.6,
        avg: 78208.93,
        max: 79835.26,
    },
    {
        ranking: '0.23',
        min: 72016.85,
        avg: 74502.70000000001,
        max: 76988.55,
    },
    {
        ranking: '0.24',
        min: 70413.41,
        avg: 71154.51000000001,
        max: 71895.61,
    },
    {
        ranking: '0.25',
        min: 68605.78,
        avg: 74738.125,
        max: 80870.47,
    },
    {
        ranking: '0.26',
        min: 65109.06,
        avg: 67077.45999999999,
        max: 69045.86,
    },
    {
        ranking: '0.27',
        min: 63147.67,
        avg: 67241.315,
        max: 71334.96,
    },
    {
        ranking: '0.28',
        min: 61467.59,
        avg: 64090.65,
        max: 66713.71,
    },
    {
        ranking: '0.29',
        min: 62311.2,
        avg: 62311.2,
        max: 62311.2,
    },
    {
        ranking: '0.30',
        min: 58725.16,
        avg: 62709.12,
        max: 66693.08,
    },
    {
        ranking: '0.31',
        min: 59152.55,
        avg: 60862.895000000004,
        max: 62573.24,
    },
    {
        ranking: '0.32',
        min: 57020.91,
        avg: 58555.87,
        max: 60090.83,
    },
    {
        ranking: '0.33',
        min: 54764.93,
        avg: 56795.869999999995,
        max: 58826.81,
    },
    {
        ranking: '0.34',
        min: 55543.21,
        avg: 56975.3,
        max: 58407.39,
    },
    {
        ranking: '0.35',
        min: 50500.77,
        avg: 52592.99,
        max: 54685.21,
    },
    {
        ranking: '0.36',
        min: 52617.17,
        avg: 52617.17,
        max: 52617.17,
    },
    {
        ranking: '0.37',
        min: 50949.58,
        avg: 59768.465000000004,
        max: 68587.35,
    },
    {
        ranking: '0.38',
        min: 48556.51,
        avg: 50812.84,
        max: 53069.17,
    },
    {
        ranking: '0.39',
        min: 50294.38,
        avg: 51386.86,
        max: 52479.34,
    },
    {
        ranking: '0.40',
        min: 48593.02,
        avg: 49391.645,
        max: 50190.27,
    },
    {
        ranking: '0.41',
        min: 47436.59,
        avg: 48649.925,
        max: 49863.26,
    },
    {
        ranking: '0.42',
        min: 45986.85,
        avg: 48212.375,
        max: 50437.9,
    },
    {
        ranking: '0.43',
        min: 46287.82,
        avg: 47323.665,
        max: 48359.51,
    },
    {
        ranking: '0.45',
        min: 44044.19,
        avg: 45832.795,
        max: 47621.4,
    },
    {
        ranking: '0.46',
        min: 44277.03,
        avg: 47249.375,
        max: 50221.72,
    },
    {
        ranking: '0.47',
        min: 40112.08,
        avg: 43003.15,
        max: 45894.22,
    },
    {
        ranking: '0.48',
        min: 42914.6,
        avg: 43003.335,
        max: 43092.07,
    },
    {
        ranking: '0.49',
        min: 42274.1,
        avg: 43703.215,
        max: 45132.33,
    },
    {
        ranking: '0.50',
        min: 40993.73,
        avg: 41011.915,
        max: 41030.1,
    },
    {
        ranking: '0.51',
        min: 40530.72,
        avg: 41399.04,
        max: 42267.36,
    },
    {
        ranking: '0.52',
        min: 39943,
        avg: 40233.425,
        max: 40523.85,
    },
    {
        ranking: '0.53',
        min: 38642.79,
        avg: 39066.4,
        max: 39490.01,
    },
    {
        ranking: '0.54',
        min: 36475.48,
        avg: 38838.08,
        max: 41200.68,
    },
    {
        ranking: '0.55',
        min: 31450.11,
        avg: 35753.395000000004,
        max: 40056.68,
    },
    {
        ranking: '0.56',
        min: 36414.3,
        avg: 38520.375,
        max: 40626.45,
    },
    {
        ranking: '0.57',
        min: 35737.88,
        avg: 36974.91499999999,
        max: 38211.95,
    },
    {
        ranking: '0.58',
        min: 37366.12,
        avg: 37754.75,
        max: 38143.38,
    },
    {
        ranking: '0.59',
        min: 35460.14,
        avg: 36403.5,
        max: 37346.86,
    },
    {
        ranking: '0.60',
        min: 33102.73,
        avg: 34679.82000000001,
        max: 36256.91,
    },
    {
        ranking: '0.61',
        min: 35025.62,
        avg: 36193.82,
        max: 37362.02,
    },
    {
        ranking: '0.62',
        min: 34115.75,
        avg: 35606.785,
        max: 37097.82,
    },
    {
        ranking: '0.63',
        min: 33267.48,
        avg: 34814.175,
        max: 36360.87,
    },
    {
        ranking: '0.64',
        min: 32447.29,
        avg: 37123.369999999995,
        max: 41799.45,
    },
    {
        ranking: '0.65',
        min: 32333.51,
        avg: 32333.51,
        max: 32333.51,
    },
    {
        ranking: '0.66',
        min: 32433.38,
        avg: 33325.185,
        max: 34216.99,
    },
    {
        ranking: '0.67',
        min: 33123.1,
        avg: 33553.31,
        max: 33983.52,
    },
    {
        ranking: '0.68',
        min: 32689.49,
        avg: 32689.49,
        max: 32689.49,
    },
    {
        ranking: '0.69',
        min: 32355.58,
        avg: 32821.979999999996,
        max: 33288.38,
    },
    {
        ranking: '0.70',
        min: 31112.97,
        avg: 31984.705,
        max: 32856.44,
    },
    {
        ranking: '0.71',
        min: 32431.84,
        avg: 32960.03,
        max: 33488.22,
    },
    {
        ranking: '0.73',
        min: 30501.33,
        avg: 31568.53,
        max: 32635.73,
    },
    {
        ranking: '0.74',
        min: 30682.58,
        avg: 31458.57,
        max: 32234.56,
    },
    {
        ranking: '0.75',
        min: 29474.34,
        avg: 29481.47,
        max: 29488.6,
    },
    {
        ranking: '0.76',
        min: 28721.44,
        avg: 30004.535,
        max: 31287.63,
    },
    {
        ranking: '0.77',
        min: 28943.6,
        avg: 29939.934999999998,
        max: 30936.27,
    },
    {
        ranking: '0.78',
        min: 28215.21,
        avg: 29429.504999999997,
        max: 30643.8,
    },
    {
        ranking: '0.79',
        min: 30563.14,
        avg: 30958.385000000002,
        max: 31353.63,
    },
    {
        ranking: '0.80',
        min: 29543.95,
        avg: 29543.95,
        max: 29543.95,
    },
    {
        ranking: '0.81',
        min: 28501.09,
        avg: 28501.09,
        max: 28501.09,
    },
    {
        ranking: '0.82',
        min: 27465.91,
        avg: 28294.190000000002,
        max: 29122.47,
    },
    {
        ranking: '0.83',
        min: 26917.74,
        avg: 28137.75,
        max: 29357.76,
    },
    {
        ranking: '0.84',
        min: 28558.05,
        avg: 28558.05,
        max: 28558.05,
    },
    {
        ranking: '0.85',
        min: 25424.55,
        avg: 26347.995,
        max: 27271.44,
    },
    {
        ranking: '0.86',
        min: 26513.52,
        avg: 27162.195,
        max: 27810.87,
    },
    {
        ranking: '0.87',
        min: 26455.46,
        avg: 27390.105,
        max: 28324.75,
    },
    {
        ranking: '0.88',
        min: 13347.58,
        avg: 20213.3,
        max: 27079.02,
    },
    {
        ranking: '0.89',
        min: 24787.74,
        avg: 26758.165,
        max: 28728.59,
    },
    {
        ranking: '0.90',
        min: 24839.96,
        avg: 25834.895,
        max: 26829.83,
    },
    {
        ranking: '0.91',
        min: 24636.1,
        avg: 25221.39,
        max: 25806.68,
    },
    {
        ranking: '0.92',
        min: 26348.28,
        avg: 26688.965,
        max: 27029.65,
    },
    {
        ranking: '0.95',
        min: 7180.33,
        avg: 16344.955000000002,
        max: 25509.58,
    },
    {
        ranking: '0.96',
        min: 23723.9,
        avg: 24396.99,
        max: 25070.08,
    },
    {
        ranking: '0.97',
        min: 21904.04,
        avg: 23512.595,
        max: 25121.15,
    },
    {
        ranking: '0.98',
        min: 24500.65,
        avg: 25216.465,
        max: 25932.28,
    },
    {
        ranking: '0.99',
        min: 23981.21,
        avg: 24509.475,
        max: 25037.74,
    },
    {
        ranking: '1.00',
        min: 22154.46,
        avg: 23921.675,
        max: 25688.89,
    },
    {
        ranking: '1.10',
        min: 20825.97,
        avg: 22912.005,
        max: 24998.04,
    },
    {
        ranking: '1.20',
        min: 15235.84,
        avg: 18590.665,
        max: 21945.49,
    },
    {
        ranking: '1.30',
        min: 17509.6,
        avg: 19052.8,
        max: 20596,
    },
    {
        ranking: '1.40',
        min: 16809.09,
        avg: 18006.33,
        max: 19203.57,
    },
    {
        ranking: '1.50',
        min: 15293.06,
        avg: 16578.42,
        max: 17863.78,
    },
    {
        ranking: '1.60',
        min: 14078.32,
        avg: 15701.76,
        max: 17325.2,
    },
    {
        ranking: '1.70',
        min: 13941.71,
        avg: 15026.22,
        max: 16110.73,
    },
    {
        ranking: '1.80',
        min: 12609.86,
        avg: 13797.345000000001,
        max: 14984.83,
    },
    {
        ranking: '1.90',
        min: 10634.97,
        avg: 12274.045,
        max: 13913.12,
    },
    {
        ranking: '2.00',
        min: 11141.76,
        avg: 12520.89,
        max: 13900.02,
    },
    {
        ranking: '2.10',
        min: 9325.5,
        avg: 11038.29,
        max: 12751.08,
    },
    {
        ranking: '2.20',
        min: 10210.96,
        avg: 12218.91,
        max: 14226.86,
    },
    {
        ranking: '2.30',
        min: 9638.8,
        avg: 10581.18,
        max: 11523.56,
    },
    {
        ranking: '2.40',
        min: 8069.69,
        avg: 9323.685,
        max: 10577.68,
    },
    {
        ranking: '2.50',
        min: 8873.94,
        avg: 9766.565,
        max: 10659.19,
    },
    {
        ranking: '2.60',
        min: 4460.6,
        avg: 7267.7,
        max: 10074.8,
    },
    {
        ranking: '2.70',
        min: 7413.86,
        avg: 10744.65,
        max: 14075.44,
    },
    {
        ranking: '2.80',
        min: 7812.73,
        avg: 8844.295,
        max: 9875.86,
    },
    {
        ranking: '2.90',
        min: 7735.29,
        avg: 9669.63,
        max: 11603.97,
    },
    {
        ranking: '3.00',
        min: 7399.14,
        avg: 7865.465,
        max: 8331.79,
    },
    {
        ranking: '3.10',
        min: 3883.32,
        avg: 6011.995,
        max: 8140.67,
    },
    {
        ranking: '3.20',
        min: 6846.23,
        avg: 7529.88,
        max: 8213.53,
    },
    {
        ranking: '3.30',
        min: 5602.84,
        avg: 6484.525,
        max: 7366.21,
    },
    {
        ranking: '3.40',
        min: 6304.27,
        avg: 7100.285,
        max: 7896.3,
    },
    {
        ranking: '3.50',
        min: 5505.17,
        avg: 6212.42,
        max: 6919.67,
    },
    {
        ranking: '3.60',
        min: 5559.3,
        avg: 6269.82,
        max: 6980.34,
    },
    {
        ranking: '3.70',
        min: 1978.92,
        avg: 5627.275,
        max: 9275.63,
    },
    {
        ranking: '3.80',
        min: 2368.54,
        avg: 4392.575,
        max: 6416.61,
    },
    {
        ranking: '3.90',
        min: 3493.47,
        avg: 5035.375,
        max: 6577.28,
    },
    {
        ranking: '4.00',
        min: 5414.66,
        avg: 5604.45,
        max: 5794.24,
    },
    {
        ranking: '4.10',
        min: 5073.84,
        avg: 5549.46,
        max: 6025.08,
    },
    {
        ranking: '4.20',
        min: 4828.22,
        avg: 7132.889999999999,
        max: 9437.56,
    },
    {
        ranking: '4.30',
        min: 4640.19,
        avg: 4912.844999999999,
        max: 5185.5,
    },
    {
        ranking: '4.40',
        min: 4326,
        avg: 4999.535,
        max: 5673.07,
    },
    {
        ranking: '4.50',
        min: 4439.32,
        avg: 4969.4400000000005,
        max: 5499.56,
    },
    {
        ranking: '4.60',
        min: 4497.15,
        avg: 4612.975,
        max: 4728.8,
    },
    {
        ranking: '4.70',
        min: 2789.2,
        avg: 3649.36,
        max: 4509.52,
    },
    {
        ranking: '4.80',
        min: 3866.29,
        avg: 4190.175,
        max: 4514.06,
    },
    {
        ranking: '4.90',
        min: 3322.15,
        avg: 3905.16,
        max: 4488.17,
    },
    {
        ranking: '5.00',
        min: 3869.02,
        avg: 3926.1,
        max: 3983.18,
    },
    {
        ranking: '5.10',
        min: 3308.1,
        avg: 5257.75,
        max: 7207.4,
    },
    {
        ranking: '5.20',
        min: 3652.33,
        avg: 5662.605,
        max: 7672.88,
    },
    {
        ranking: '5.30',
        min: 3269.39,
        avg: 3778.335,
        max: 4287.28,
    },
    {
        ranking: '5.40',
        min: 3267.55,
        avg: 3712.59,
        max: 4157.63,
    },
    {
        ranking: '5.50',
        min: 3413.36,
        avg: 3724.9700000000003,
        max: 4036.58,
    },
    {
        ranking: '5.60',
        min: 3235.92,
        avg: 3417.44,
        max: 3598.96,
    },
    {
        ranking: '5.70',
        min: 3060.9,
        avg: 3921.9049999999997,
        max: 4782.91,
    },
    {
        ranking: '5.80',
        min: 3153.18,
        avg: 3626.58,
        max: 4099.98,
    },
    {
        ranking: '5.90',
        min: 3025.88,
        avg: 3392.8,
        max: 3759.72,
    },
    {
        ranking: '6.00',
        min: 2983,
        avg: 3534.05,
        max: 4085.1,
    },
    {
        ranking: '6.10',
        min: 2568.13,
        avg: 2907.74,
        max: 3247.35,
    },
    {
        ranking: '6.20',
        min: 2711.1,
        avg: 2858.25,
        max: 3005.4,
    },
    {
        ranking: '6.30',
        min: 2663.31,
        avg: 2971.1949999999997,
        max: 3279.08,
    },
    {
        ranking: '6.40',
        min: 1768.58,
        avg: 2250.715,
        max: 2732.85,
    },
    {
        ranking: '6.50',
        min: 2411.02,
        avg: 2607.935,
        max: 2804.85,
    },
    {
        ranking: '6.60',
        min: 2424,
        avg: 2605.7200000000003,
        max: 2787.44,
    },
    {
        ranking: '6.70',
        min: 2454.46,
        avg: 2597.11,
        max: 2739.76,
    },
    {
        ranking: '6.80',
        min: 2053.3,
        avg: 2562.365,
        max: 3071.43,
    },
    {
        ranking: '6.90',
        min: 2365.48,
        avg: 2559.5550000000003,
        max: 2753.63,
    },
    {
        ranking: '7.00',
        min: 2413.08,
        avg: 2656.2349999999997,
        max: 2899.39,
    },
    {
        ranking: '7.10',
        min: 120,
        avg: 1288.665,
        max: 2457.33,
    },
    {
        ranking: '7.20',
        min: 2423.5,
        avg: 2485.2200000000003,
        max: 2546.94,
    },
    {
        ranking: '7.30',
        min: 2321.29,
        avg: 2599.75,
        max: 2878.21,
    },
    {
        ranking: '7.40',
        min: 1160.72,
        avg: 2028.6150000000002,
        max: 2896.51,
    },
    {
        ranking: '7.50',
        min: 2184.15,
        avg: 2257.395,
        max: 2330.64,
    },
    {
        ranking: '7.60',
        min: 1925.88,
        avg: 2053.55,
        max: 2181.22,
    },
    {
        ranking: '7.70',
        min: 845.8,
        avg: 1665.975,
        max: 2486.15,
    },
    {
        ranking: '7.80',
        min: 1938.92,
        avg: 2048.02,
        max: 2157.12,
    },
    {
        ranking: '7.90',
        min: 259.5,
        avg: 1297.51,
        max: 2335.52,
    },
    {
        ranking: '8.00',
        min: 1747.71,
        avg: 2221.145,
        max: 2694.58,
    },
    {
        ranking: '8.10',
        min: 1973.02,
        avg: 2033.685,
        max: 2094.35,
    },
    {
        ranking: '8.20',
        min: 555,
        avg: 1307.975,
        max: 2060.95,
    },
    {
        ranking: '8.30',
        min: 1710.57,
        avg: 1842.33,
        max: 1974.09,
    },
    {
        ranking: '8.40',
        min: 1799.78,
        avg: 1873.26,
        max: 1946.74,
    },
    {
        ranking: '8.50',
        min: 1715.98,
        avg: 1891.845,
        max: 2067.71,
    },
    {
        ranking: '8.60',
        min: 377.96,
        avg: 1180.225,
        max: 1982.49,
    },
    {
        ranking: '8.70',
        min: 1361.85,
        avg: 1766.135,
        max: 2170.42,
    },
    {
        ranking: '8.80',
        min: 1798.4,
        avg: 2506.545,
        max: 3214.69,
    },
    {
        ranking: '8.90',
        min: 1561,
        avg: 1642.98,
        max: 1724.96,
    },
    {
        ranking: '9.00',
        min: 1610.67,
        avg: 1610.67,
        max: 1610.67,
    },
    {
        ranking: '9.10',
        min: 1200.56,
        avg: 1484.51,
        max: 1768.46,
    },
    {
        ranking: '9.20',
        min: 1437.92,
        avg: 1558.71,
        max: 1679.5,
    },
    {
        ranking: '9.30',
        min: 1494.81,
        avg: 1610.545,
        max: 1726.28,
    },
    {
        ranking: '9.40',
        min: 1348.02,
        avg: 1475.73,
        max: 1603.44,
    },
    {
        ranking: '9.50',
        min: 858,
        avg: 1199,
        max: 1540,
    },
    {
        ranking: '9.70',
        min: 1557,
        avg: 1567.51,
        max: 1578.02,
    },
    {
        ranking: '9.80',
        min: 1027.67,
        avg: 1290.8200000000002,
        max: 1553.97,
    },
    {
        ranking: '10.00',
        min: 1259.16,
        avg: 1591.45,
        max: 1923.74,
    },
    {
        ranking: '11.00',
        min: 945.17,
        avg: 1214.835,
        max: 1484.5,
    },
    {
        ranking: '12.00',
        min: 606.98,
        avg: 909.295,
        max: 1211.61,
    },
    {
        ranking: '13.00',
        min: 634.19,
        avg: 2049.5299999999997,
        max: 3464.87,
    },
    {
        ranking: '14.00',
        min: 36.96,
        avg: 547.755,
        max: 1058.55,
    },
    {
        ranking: '15.00',
        min: 191.75,
        avg: 906.305,
        max: 1620.86,
    },
    {
        ranking: '16.00',
        min: 510.92,
        avg: 781.5300000000001,
        max: 1052.14,
    },
    {
        ranking: '17.00',
        min: 305.95,
        avg: 2834.49,
        max: 5363.03,
    },
    {
        ranking: '18.00',
        min: 294.7,
        avg: 1697.35,
        max: 3100,
    },
    {
        ranking: '19.00',
        min: 426.79,
        avg: 569.15,
        max: 711.51,
    },
];

export interface PerformerRankingDataPoint {
    ranking: string;
    min: number;
    avg: number;
    max: number;
}

const OnlyFansRankingsChartLinear = ({ data }: { data: PerformerRankingDataPoint[] }) => {
    const theme: Theme = useTheme();
    const chartRef = useRef<HTMLDivElement>(null);
    const [dimensions, setDimensions] = useState({ width: 0, height: 0 });

    useEffect(() => {
        const resizeObserver = new ResizeObserver(entries => {
            for (let entry of entries) {
                const { width, height } = entry.contentRect;
                setDimensions({ width, height });
            }
        });

        if (chartRef.current) {
            resizeObserver.observe(chartRef.current);
        }

        return () => {
            resizeObserver.disconnect();
        };
    }, []);

    useEffect(() => {
        if (chartRef.current && dimensions.width > 0 && dimensions.height > 0) {
            drawChart();
        }
    }, [dimensions]);

    const drawChart = (): void => {
        const margin = { top: 20, right: 30, bottom: 100, left: 65 };
        const width = dimensions.width - margin.left - margin.right;
        const height = dimensions.height - margin.top - margin.bottom;
        const brushHeight = 50;

        d3.select(chartRef.current).selectAll('svg').remove();

        const svg = d3
            .select(chartRef.current)
            .append('svg')
            .attr('width', width + margin.left + margin.right)
            .attr('height', height + margin.top + margin.bottom + brushHeight)
            .append('g')
            .attr('transform', `translate(${margin.left},${margin.top})`);

        // Parse ranking strings to numbers for scaling
        const rankingValues = data.map(d => parseFloat(d.ranking));

        // Changed to scaleLinear
        const x = d3
            .scaleLinear()
            .range([0, width])
            .domain([0, (d3.max(rankingValues) || 0.2) + 0.01]); // Add 5% extra space

        const y = d3
            .scaleLinear()
            .range([height, 0])
            .domain([0, (d3.max(data, d => d.max) || 0) * 1.1]); // Add 10% extra space

        const xAxis = d3.axisBottom(x).tickFormat(
            d =>
                `${d.toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                })}%`,
        );
        const yAxis = d3.axisLeft(y).tickFormat(d => `$${d3.format('.2s')(d)}`);

        // Clip path
        svg.append('defs').append('clipPath').attr('id', 'clip').append('rect').attr('width', width).attr('height', height);

        // Main chart group
        const mainChart = svg.append('g').attr('clip-path', 'url(#clip)');

        // Add grid lines
        const gridGroup = mainChart.append('g').attr('class', 'grid-lines');

        function updateGrid() {
            gridGroup.selectAll('.grid-line').remove();
            const yTicks = y.ticks();
            gridGroup
                .selectAll('.grid-line')
                .data(yTicks.slice(1)) // Exclude the first tick
                .enter()
                .append('line')
                .attr('class', 'grid-line')
                .attr('x1', 0)
                .attr('x2', width)
                .attr('y1', d => y(d))
                .attr('y2', d => y(d))
                .attr('stroke', '#e0e0e0')
                .attr('stroke-width', 1);
        }

        const xAxisGroup = svg
            .append('g')
            .attr('class', 'x-axis')
            .style('font-size', '11px')
            .attr('transform', `translate(0,${height})`)
            .call(xAxis);

        const yAxisGroup = svg.append('g').attr('class', 'y-axis').style('font-size', '11px').call(yAxis);

        const minMaxLines = mainChart
            .selectAll('.minmax-line')
            .data(data)
            .enter()
            .append('line')
            .attr('class', 'minmax-line')
            .attr('stroke', 'black')
            .attr('stroke-width', 1);

        const maxLines = mainChart
            .selectAll('.max-line')
            .data(data)
            .enter()
            .append('line')
            .attr('class', 'max-line')
            .attr('stroke', 'black')
            .attr('stroke-width', 1);

        const minLines = mainChart
            .selectAll('.min-line')
            .data(data)
            .enter()
            .append('line')
            .attr('class', 'min-line')
            .attr('stroke', 'black')
            .attr('stroke-width', 1);

        // add ranking label above the max line
        const maxLabels = mainChart
            .selectAll('.max-label')
            .data(data)
            .enter()
            .append('text')
            .attr('class', 'max-label')
            .attr('text-anchor', 'middle')
            .attr('dy', '-1em')
            .attr('fill', 'black')
            .attr('font-size', '10px')
            .text(d => `${d.ranking}%`);

        const tooltip = d3
            .select(chartRef.current)
            .append('div')
            .attr('class', 'tooltip')
            .style('opacity', 0)
            .style('position', 'absolute')
            .style('background-color', 'white')
            .style('border', 'solid')
            .style('border-width', '1px')
            .style('border-radius', '5px')
            .style('padding', '10px');

        const avgDots = mainChart
            .selectAll('.avg-dot')
            .data(data)
            .enter()
            .append('circle')
            .attr('class', 'avg-dot')
            .attr('r', 3)
            .attr('fill', theme.palette.primary.main)
            .on('mouseover', (event: MouseEvent, d: PerformerRankingDataPoint) => {
                tooltip.transition().duration(200).style('opacity', 0.9);
                const tooltipWidth = 200; // Approximate width of the tooltip
                const tooltipHeight = 100; // Approximate height of the tooltip
                // const xPosition = x(d.ranking);
                // const yPosition = y(d.avg);

                let left = event.pageX + 10;
                let top = event.pageY - 28;

                // Adjust tooltip position if it would overflow the right side of the chart
                if (left + tooltipWidth > dimensions.width) {
                    left = event.pageX - tooltipWidth - 10;
                }

                // Adjust tooltip position if it would overflow the bottom of the chart
                if (top + tooltipHeight > dimensions.height) {
                    top = event.pageY - tooltipHeight - 10;
                }

                tooltip
                    .html(
                        `<table cellspacing="2" cellpadding="2" border="0">
                        <tr>
                            <td><strong>Ranking</strong></td>
                            <td><strong>${d.ranking}%</strong></td>
                        </tr>
                        <tr>
                            <td>Min:</td>
                            <td>$${d.min.toLocaleString(undefined, {
                                minimumFractionDigits: 0,
                                maximumFractionDigits: 0,
                            })}</td>
                        </tr>
                        <tr>
                            <td>Avg:</td>
                            <td>$${d.avg.toLocaleString(undefined, {
                                minimumFractionDigits: 0,
                                maximumFractionDigits: 0,
                            })}</td>
                        </tr>
                        <tr>
                            <td>Max:</td>
                            <td>$${d.max.toLocaleString(undefined, {
                                minimumFractionDigits: 0,
                                maximumFractionDigits: 0,
                            })}</td>
                        </tr>
                    </table>`,
                    )
                    .style('left', `${left}px`)
                    .style('top', `${top}px`);
            })
            .on('mouseout', () => {
                tooltip.transition().duration(500).style('opacity', 0);
            });

        // X-axis label
        svg.append('text')
            .attr('x', width / 2)
            .attr('y', height + margin.bottom - 60)
            .attr('text-anchor', 'middle')
            .style('font-size', '12px')
            .text('Ranking Percentage');

        // Y-axis label
        svg.append('text')
            .attr('transform', 'rotate(-90)')
            .attr('y', 0 - margin.left)
            .attr('x', 0 - height / 2)
            .attr('dy', '1em')
            .style('text-anchor', 'middle')
            .style('font-size', '12px')
            .text('Earnings per Month (Gross, USD)');

        // Brush
        const brush = d3
            .brushX()
            .extent([
                [0, 0],
                [width, brushHeight],
            ])
            .on('brush end', brushed);

        const context = svg
            .append('g')
            .attr('class', 'context')
            .attr('transform', `translate(0,${height + margin.top + 20})`);

        const xBrush = x.copy();
        const yBrush = d3.scaleLinear().range([brushHeight, 0]).domain(y.domain());

        // Add the brush overview area
        context
            .append('g')
            .selectAll('line')
            .data(data)
            .enter()
            .append('line')
            .attr('x1', (d: PerformerRankingDataPoint) => xBrush(parseFloat(d.ranking)))
            .attr('x2', (d: PerformerRankingDataPoint) => xBrush(parseFloat(d.ranking)))
            .attr('y1', (d: PerformerRankingDataPoint) => yBrush(d.min))
            .attr('y2', (d: PerformerRankingDataPoint) => yBrush(d.max))
            .attr('stroke', 'black')
            .attr('stroke-width', 1);

        context
            .append('g')
            .selectAll('circle')
            .data(data)
            .enter()
            .append('circle')
            .attr('cx', (d: PerformerRankingDataPoint) => xBrush(parseFloat(d.ranking)))
            .attr('cy', (d: PerformerRankingDataPoint) => yBrush(d.avg))
            .attr('r', 2)
            .attr('fill', theme.palette.primary.main);

        context
            .append('g')
            .attr('class', 'axis axis--x')
            .attr('transform', `translate(0,${brushHeight})`)
            .call(
                d3.axisBottom(xBrush).tickFormat(
                    d =>
                        `${d.toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                        })}%`,
                ),
            );

        context
            .append('g')
            .attr('class', 'brush')
            .call(brush)
            .call(brush.move, [0, xBrush(0.2)]);

        function updateChart(xDomain: [number, number]) {
            x.domain(xDomain);

            const visibleData = data.filter(d => {
                const rankingValue = parseFloat(d.ranking);
                return rankingValue >= xDomain[0] && rankingValue <= xDomain[1];
            });
            const yDomain = [0, (d3.max(visibleData, d => d.max) || 0) * 1.1];

            y.domain(yDomain);

            xAxisGroup.call(xAxis as any);
            yAxisGroup.call(yAxis as any);

            updateGrid(); // Update grid lines

            minMaxLines
                .attr('x1', d => x(parseFloat(d.ranking)))
                .attr('x2', d => x(parseFloat(d.ranking)))
                .attr('y1', d => y(d.min))
                .attr('y2', d => y(d.max));

            maxLines
                .attr('x1', d => x(parseFloat(d.ranking)) - 5)
                .attr('x2', d => x(parseFloat(d.ranking)) + 5)
                .attr('y1', d => y(d.max))
                .attr('y2', d => y(d.max));

            minLines
                .attr('x1', d => x(parseFloat(d.ranking)) - 5)
                .attr('x2', d => x(parseFloat(d.ranking)) + 5)
                .attr('y1', d => y(d.min))
                .attr('y2', d => y(d.min));

            maxLabels.attr('x', d => x(parseFloat(d.ranking))).attr('y', d => y(d.max));

            avgDots.attr('cx', d => x(parseFloat(d.ranking))).attr('cy', d => y(d.avg));
        }

        function brushed(event: d3.D3BrushEvent<unknown>) {
            if (event.selection) {
                // Get the selected range
                const [x0, x1] = event.selection as [number, number];
                const newXDomain: [number, number] = [xBrush.invert(x0), xBrush.invert(x1)];

                updateChart(newXDomain);
            }
        }
    };

    return <div ref={chartRef} style={{ width: '100%', height: '100%' }} />;
};

const RankingSelector = ({
    selectedRanking,
    setSelectedRanking,
    data,
}: {
    selectedRanking: number;
    setSelectedRanking: (ranking: number) => void;
    data: PerformerRankingDataPoint[];
}) => {
    const theme: Theme = useTheme();

    const handleChange = (event: Event, value: number | number[]) => {
        if (typeof value === 'number') {
            setSelectedRanking(value);
        }
    };

    return (
        <Box sx={{ width: '100%' }}>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <Slider
                        value={selectedRanking}
                        onChange={handleChange}
                        valueLabelDisplay="auto"
                        step={0.1}
                        min={parseFloat(data[0].ranking)}
                        max={parseFloat(data[data.length - 1].ranking)}
                        marks={[
                            { value: 0, label: '0%' },
                            { value: 5, label: '5%' },
                            { value: 10, label: '10%' },
                            { value: 15, label: '15%' },
                            { value: 20, label: '20%' },
                        ]}
                    />
                </Grid>
                <Grid item xs={12}>
                    <Typography variant="body2" color="textSecondary">
                        Selected ranking: {selectedRanking.toFixed(2)}%
                    </Typography>
                </Grid>
            </Grid>
        </Box>
    );
};

const PerformerRanking = () => {
    const settingsContext = useContext(SettingsContext);
    const theme: Theme = useTheme();

    const { data: performerTop, isLoading: isPerformerTopLoading } = useSubscriberPerformerTop();
    const { data: subscriber, isLoading: isSubscriberLoading } = useSubscriber();

    const [myRanking, setMyRanking] = useState<number>(0);
    const [selectedRanking, setSelectedRanking] = useState<number>(0);

    useEffect(() => {
        if (performerTop && performerTop.performerTop < parseFloat(data[data.length - 1].ranking)) {
            setSelectedRanking(performerTop.performerTop);
            setMyRanking(performerTop.performerTop);
        } else {
            setSelectedRanking(0);
        }
    }, [performerTop]);

    return (
        <PageContainer>
            {subscriber && '_id' in subscriber && subscriber._id && (
                <>
                    <Typography variant="h5" sx={{ marginBottom: 2 }}>
                        <BackNavigationButton
                            url={`/subscribers/${subscriber._id || ''}/${settingsContext.services.messageUsers.homeUrl}`}
                        />{' '}
                        OnlyFans Performer Ranking
                    </Typography>

                    <PerformerRankingMyRankingCard myRanking={myRanking} isPerformerTopLoading={isPerformerTopLoading} data={data} />

                    <Card sx={{ width: '100%', marginBottom: 2 }}>
                        <CardContent>
                            <Grid container flexGrow={1} spacing={2} sx={{ marginBottom: 1 }}>
                                <Grid item xs={12}>
                                    <Typography variant="h5">Current Rankings</Typography>
                                    <Typography variant="caption" color="textSecondary">
                                        Updated {moment().format('LL')}
                                    </Typography>
                                    <Typography variant="body1" gutterBottom sx={{ mt: 1 }}>
                                        The following graph shows an approximation of what level of earnings a month is required to reach a
                                        certain ranking on OnlyFans.
                                    </Typography>
                                    <Typography variant="body1" gutterBottom>
                                        Please bear in mind that these are figures that are based on a sample of OnlyFans performers and may
                                        not be 100% accurate as we don't know exactly how OnlyFans calculates their rankings. But
                                        nevertheless, it should give you a rough idea of what you need to earn to reach a certain ranking.
                                    </Typography>
                                    <Typography variant="body1">
                                        Each data point below represents a ranking percentage (X axis), the minimum (lower horizontal line),
                                        average (blue dot), and maximum (upper horizontal line) earnings (Y axis) for a given ranking.
                                    </Typography>
                                </Grid>
                                <Grid item xs={12}>
                                    <RankingSelector
                                        selectedRanking={selectedRanking}
                                        setSelectedRanking={setSelectedRanking}
                                        data={data}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <Box sx={{ height: '500px' }}>
                                        <OnlyFansRankingsChartLinear data={data} />
                                    </Box>
                                </Grid>
                                <Grid item xs={12} textAlign="center">
                                    <Typography variant="body2" color="textSecondary">
                                        Use the slider above to zoom in on a specific ranking range.
                                    </Typography>
                                </Grid>
                            </Grid>
                        </CardContent>
                    </Card>
                </>
            )}
        </PageContainer>
    );
};

export default PerformerRanking;
